"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleReset = exports.HandleNavigateForward = exports.HandleNavigateBack = exports.GetTestIds = void 0;
var QuizPanelMethods = _interopRequireWildcard(require("./QuizPanel"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuizProvider = require("./QuizProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _boolean = require("../../utils/type-checks/boolean");
var _function = require("../../utils/type-checks/function");
var _number = require("../../utils/type-checks/number");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  GetTestIds = testId => ({
    actions: (0, _string.isStringOfLength)(testId) ? `${testId}__actions` : undefined,
    component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
    header: (0, _string.isStringOfLength)(testId) ? `${testId}__header` : undefined,
    progress: (0, _string.isStringOfLength)(testId) ? `${testId}__linear-progress` : undefined,
    progressHeader: (0, _string.isStringOfLength)(testId) ? `${testId}__progress-header` : undefined,
    title: (0, _string.isStringOfLength)(testId) ? `${testId}__title` : undefined
  }),
  HandleNavigateBack = (e, dispatch, onNavigateBack) => {
    const result = {
      dispatch: false,
      onNavigateBack: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "navigatePanelBack"
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onNavigateBack)) {
      onNavigateBack(e);
      result.onNavigateBack = true;
    }
    return result;
  },
  HandleNavigateForward = (e, dispatch, onNavigateForward) => {
    const result = {
      dispatch: false,
      onNavigateForward: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "navigatePanelForward"
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onNavigateForward)) {
      onNavigateForward(e);
      result.onNavigateForward = true;
    }
    return result;
  },
  HandleReset = (e, dispatch, onReset) => {
    const result = {
      dispatch: false,
      onReset: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "resetState"
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onReset)) {
      onReset(e);
      result.onReset = true;
    }
    return result;
  };

/**
 * Quiz Modal Panel Component
 *
 * @visibleName Quiz Panel
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.HandleReset = HandleReset;
exports.HandleNavigateForward = HandleNavigateForward;
exports.HandleNavigateBack = HandleNavigateBack;
exports.GetTestIds = GetTestIds;
const QuizPanel = props => {
  const {
      backButtonText = "Previous",
      children,
      className,
      customActions,
      customTheme = {},
      disableNext = false,
      fragmentId,
      hideActions = false,
      hideBack = true,
      hideHeader = false,
      hideNavigateButton = false,
      hideReset = false,
      hideTitle = false,
      navigateButtonText = "Next",
      onNavigateBack,
      onNavigateForward,
      onReset,
      questionCountHeading = "Question",
      questionCountTag = "h2",
      questionsCurrent = 1,
      questionsTotal,
      resetButtonText = "Reset",
      styles = {},
      testId,
      testLoaded,
      title,
      titleTag = "h1"
    } = props,
    descriptionId = "quiz__modal-panel-progress-description",
    quizTheme = _QuizProvider.Methods.useCustomTheme(),
    theme = merge.all([(0, _styles.useTheme)(), quizTheme, customTheme]),
    dispatch = _QuizProvider.Methods.useDispatch(),
    {
      direction
    } = _QuizProvider.Methods.useState(),
    customClasses = (0, _classnames.default)({
      "quiz__modal-panel": true,
      [`${className}`]: className
    }),
    customStyles = merge({
      ".quiz__modal-panel-heading": {
        textAlign: "left",
        ".heading--isInteriorPageSubHeading": {
          marginTop: "0.8rem",
          paddingRight: "1.5rem",
          textAlign: "inherit"
        },
        ".heading--isInteriorPageSubHeadingCaption": {
          color: theme.quiz.linearProgress.subheadingColor,
          mt: 2,
          textAlign: "inherit"
        }
      },
      ".quiz__modal-panel-progress": {
        backgroundColor: theme.quiz.linearProgress.backgroundColor,
        borderRadius: "0.45rem",
        marginTop: "1.9rem",
        minHeight: "0.9rem",
        ".MuiLinearProgress-bar": {
          backgroundColor: theme.quiz.linearProgress.color
        }
      },
      ".quiz__modal-panel-actions": {
        alignItems: "center",
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        paddingTop: "1rem",
        ".MuiButton-root": {
          minWidth: "unset",
          padding: {
            xs: "0.9rem 2rem",
            md: "1.3rem 2rem"
          }
        },
        ".quiz__modal-panel-actions--isPrimary": {
          alignItems: "center",
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "flex-start"
        },
        ".quiz__modal-panel-button--isReset": {
          fontSize: "1.8rem"
        }
      }
    }, styles),
    testIdObject = QuizPanelMethods.GetTestIds(testId),
    [question, setQuestion] = (0, _react.useState)(questionsCurrent - direction),
    [loaded, setLoaded] = (0, _react.useState)((0, _boolean.isBoolean)(testLoaded) ? testLoaded : false),
    handleNavigateBack = e => QuizPanelMethods.HandleNavigateBack(e, dispatch, onNavigateBack),
    handleNavigateForward = e => QuizPanelMethods.HandleNavigateForward(e, dispatch, onNavigateForward),
    handleReset = e => QuizPanelMethods.HandleReset(e, dispatch, onReset);
  (0, _react.useLayoutEffect)(() => {
    const timeOutId = setTimeout(() => {
      if (!loaded) {
        setQuestion(question => question + direction);
      }
      setLoaded(true);
    }, 5);
    return () => {
      clearTimeout(timeOutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: customClasses,
    "data-testid": testIdObject.component,
    sx: customStyles
  }, !hideHeader && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-panel-heading",
    "data-testid": testIdObject.header
  }, !hideTitle && (0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "heading--isInteriorPageSubHeading",
    component: titleTag,
    "data-testid": testIdObject.title
  }, title), !hideTitle && title && !(0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    "data-testid": testIdObject.title
  }, title), (0, _number.isNumber)(questionsCurrent) && (0, _number.isNumber)(questionsTotal) && question >= 0 && questionsCurrent <= questionsTotal && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _string.isStringOfLength)(questionCountHeading) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "heading--isInteriorPageSubHeadingCaption",
    component: questionCountTag,
    "data-testid": testIdObject.progressHeader,
    id: descriptionId
  }, questionCountHeading, " ", questionsCurrent, " of ", questionsTotal), questionCountHeading && !(0, _string.isStringOfLength)(questionCountHeading) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    "data-testid": testIdObject.progressHeader,
    id: descriptionId
  }, questionCountHeading), /*#__PURE__*/_react.default.createElement(_material.LinearProgress, {
    className: "quiz__modal-panel-progress",
    "aria-labelledby": questionCountHeading ? descriptionId : undefined,
    "data-testid": testIdObject.progress,
    value: Math.round(question / questionsTotal * 100),
    variant: "determinate"
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-panel-content"
  }, fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children), !hideActions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-panel-actions",
    "data-testid": testIdObject.actions
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-panel-actions--isPrimary"
  }, !hideNavigateButton && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__modal-panel-button quiz__modal-panel-button--isNext",
    onClick: handleNavigateForward,
    disabled: disableNext,
    variant: "primary"
  }, navigateButtonText), !hideReset && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__modal-panel-button quiz__modal-panel-button--isReset",
    onClick: handleReset,
    variant: "ctalink"
  }, resetButtonText), customActions), /*#__PURE__*/_react.default.createElement(_material.Box, null, !hideBack && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__modal-panel-button quiz__modal-panel-button--isBack",
    onClick: handleNavigateBack,
    variant: "secondary"
  }, backButtonText))));
};

// Define propTypes;
QuizPanel.propTypes = {
  /** Text for navigate back button (Default Value: "Previous") */
  backButtonText: _propTypes.default.string,
  /** Panel child content */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom classname for panel */
  className: _propTypes.default.string,
  /** Custom Actions Component */
  customActions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom Theme Object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to disable next button (Default Value: false) */
  disableNext: _propTypes.default.bool,
  /** Fragment Id for content fragment */
  fragmentId: _propTypes.default.string,
  /** Boolean to hide/show default action buttons (Default Value: false) */
  hideActions: _propTypes.default.bool,
  /** Boolean to hide back button (Default Value: true) */
  hideBack: _propTypes.default.bool,
  /** Boolean to hide header (Defaut Value: false) */
  hideHeader: _propTypes.default.bool,
  /** Boolean to hide default button (Default Value: false) */
  hideNavigateButton: _propTypes.default.bool,
  /** Boolean to hide reset quiz button (Default Value: false) */
  hideReset: _propTypes.default.bool,
  /** Boolean to hide title component (Default Value: false) */
  hideTitle: _propTypes.default.bool,
  /** Text for "next" navigation button (Default Value: "Next") */
  navigateButtonText: _propTypes.default.string,
  /** Custom navigate back method */
  onNavigateBack: _propTypes.default.func,
  /** Custom navigate forward method */
  onNavigateForward: _propTypes.default.func,
  /** Custom quiz reset method */
  onReset: _propTypes.default.func,
  /** Question count text (Default Value: "Question") */
  questionCountHeading: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string, _propTypes.default.bool]),
  /** HTML Tag for Question Count Component (Default Value: "h2") */
  questionCountTag: _propTypes.default.string,
  /** Number of current question for the linear progress indicator (Default Value: 1) */
  questionsCurrent: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  /** Number of total questions for the linear progress indicator */
  questionsTotal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  /** Reset button question (Default Value: "Reset") */
  resetButtonText: _propTypes.default.string,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** @ignore */
  testLoaded: _propTypes.default.bool,
  /** Panel Title */
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Tag for Title Text (Default Value: "h1") */
  titleTag: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = QuizPanel;